module.exports = __webpack_public_path__ + "media/images/lp/donation3-title-pc-0b49e37b73982709bb92846ee56c18f7.png";